/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_individual_profile_usecase_payments = /** @type {(inputs: {}) => string} */ () => {
	return `Enviar y recibir pagos`
};

const en_onboarding_individual_profile_usecase_payments = /** @type {(inputs: {}) => string} */ () => {
	return `Send & receive payments`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_individual_profile_usecase_payments = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_individual_profile_usecase_payments(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_individual_profile_usecase_payments", locale)
	if (locale === "es") return es_onboarding_individual_profile_usecase_payments(inputs)
	return en_onboarding_individual_profile_usecase_payments(inputs)
};
export { onboarding_individual_profile_usecase_payments as "onboarding.individual_profile.usecase_payments" }